export enum FeedStatus {
  Idle = 'idle',
  Refreshing = 'refreshing',
  Healthy = 'healthy',
  Failed = 'failed'
}
